// Thin wrapper around Plausible's custom-event API.
//
// The loader in `Plausible.jsx` exposes a global `window.plausible(...)`
// function that queues calls until the real script is ready, so we can fire
// events even before the network has finished fetching the snippet.
//
// Usage:
//   track('intro_status', { type: 'skipped' });
//   track('intro_status', { type: 'completed' });

export function track(eventName, props) {
  if (typeof window === "undefined") return;
  const fn = window.plausible;
  if (typeof fn !== "function") return;  // Plausible loader not mounted.
  if (props && typeof props === "object") {
    fn(eventName, { props });
  } else {
    fn(eventName);
  }
}
